"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.number.constructor");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.string.pad-start");

var _car = require("@/api/cms/car");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'TransportCapacity',
  data: function data() {
    return {
      searchForm: {
        vehicleNumber: '',
        energyType: '',
        date: ''
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      statsData: {
        totalVehicles: 0,
        availableVehicles: 0,
        busyVehicles: 0
      },
      tableData: [],
      tableLoading: false,
      dateList: [],
      tableHeight: 400,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      form: {
        id: '',
        carNumber: '',
        brand: '',
        style: '',
        energy: '',
        volume: '',
        weight: '',
        size: '',
        box: '',
        userId: '',
        coordinateX: '',
        coordinateY: '',
        status: 0
      },
      rules: {
        carNumber: [{
          required: true,
          message: '请输入车牌号',
          trigger: 'blur'
        }],
        brand: [{
          required: true,
          message: '请输入品牌',
          trigger: 'blur'
        }],
        energy: [{
          required: true,
          message: '请选择补能方式',
          trigger: 'change'
        }]
      },
      mapDialogVisible: false,
      tempCoordinate: '',
      map: null,
      marker: null,
      searchKeyword: '',
      showSearchResults: false,
      searchResults: [],
      searchTimer: null,
      viewMode: 'table',
      vehicleMap: null,
      vehicleMarkers: [],
      vehicleInfoWindow: null
    };
  },
  computed: {
    amapApi: function amapApi() {
      return this.$store.state.api.amapApi;
    },
    amapSecurityJsCode: function amapSecurityJsCode() {
      return this.$store.state.api.amapSecurityJsCode;
    },
    coordinateDisplay: function coordinateDisplay() {
      if (this.form.coordinateX && this.form.coordinateY) {
        return "".concat(this.form.coordinateY, ", ").concat(this.form.coordinateX);
      }

      return '';
    }
  },
  watch: {
    tableData: {
      handler: function handler() {
        var _this = this;

        if (this.viewMode === 'map' && this.vehicleMap) {
          this.$nextTick(function () {
            _this.addVehicleMarkers();
          });
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.initDateList();
    this.initTableHeight();
    this.getList();
    this.getStats();
    window.addEventListener('resize', this.initTableHeight);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.initTableHeight);

    if (this.vehicleMap) {
      this.vehicleMap.destroy();
      this.vehicleMap = null;
    }
  },
  methods: {
    handleDateChange: function handleDateChange(date) {
      this.pagination.page = 1;
      this.initDateList(date);
      this.getList(date);
    },
    initDateList: function initDateList(startDate) {
      var dates = [];
      var baseDate;

      if (startDate) {
        baseDate = new Date(startDate);
      } else {
        baseDate = new Date();
      }

      for (var i = 0; i < 7; i++) {
        var date = new Date(baseDate);
        date.setDate(baseDate.getDate() + i);
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        dates.push("".concat(month, "-").concat(day));
      }

      this.dateList = dates;
    },
    formatDate: function formatDate(date, format) {
      if (typeof date === 'string') {
        if (format === 'MM-DD') {
          return date;
        } else if (format === 'EEE') {
          var parts = date.split('-');

          var _d = new Date(new Date().getFullYear(), parseInt(parts[0]) - 1, parseInt(parts[1]));

          var today = new Date();
          var _weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

          var _weekDay = _weekDays[_d.getDay()];

          if (_d.getMonth() === today.getMonth() && _d.getDate() === today.getDate()) {
            return "".concat(_weekDay, "(\u4ECA\u65E5)");
          }

          return _weekDay;
        }

        return date;
      }

      var d = new Date(date);
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      var weekDay = weekDays[d.getDay()];

      if (format === 'MM-DD') {
        return "".concat(month, "-").concat(day);
      } else if (format === 'EEE') {
        var _today = new Date();

        if (d.getMonth() === _today.getMonth() && d.getDate() === _today.getDate()) {
          return "".concat(weekDay, "(\u4ECA\u65E5)");
        }

        return weekDay;
      }

      return "".concat(month, "-").concat(day);
    },
    getScheduleStatus: function getScheduleStatus(schedules, date) {
      if (!schedules) return 'free';
      var dateStr = this.formatDate(date, 'MM-DD');
      var schedule = schedules.find(function (s) {
        return s.date === dateStr;
      });
      return schedule && schedule.status === 'busy' ? 'busy' : 'free';
    },
    getScheduleTime: function getScheduleTime(schedules, date) {
      if (!schedules) return '';
      var dateStr = this.formatDate(date, 'MM-DD');
      var schedule = schedules.find(function (s) {
        return s.date === dateStr;
      });
      return schedule && schedule.time ? schedule.time : '';
    },
    getTaskStatus: function getTaskStatus(taskTimes, date) {
      if (!taskTimes) return 0;
      var dateStr = this.formatDate(date, 'MM-DD');
      var task = taskTimes.find(function (t) {
        return t.taskDate === dateStr;
      });
      return task && task.status !== undefined ? task.status : 0;
    },
    getTaskTime: function getTaskTime(taskTimes, date) {
      if (!taskTimes) return '';
      var dateStr = this.formatDate(date, 'MM-DD');
      var task = taskTimes.find(function (t) {
        return t.taskDate === dateStr;
      });
      return task && task.taskTime ? task.taskTime : '';
    },
    getTaskTimesList: function getTaskTimesList(taskTimes, date) {
      if (!taskTimes) return [];
      var dateStr = this.formatDate(date, 'MM-DD');
      var tasks = taskTimes.filter(function (t) {
        return t.taskDate === dateStr;
      });
      return tasks.map(function (t) {
        return t.taskTime;
      }).filter(function (t) {
        return t;
      });
    },
    getScheduleStatusByPeriod: function getScheduleStatusByPeriod(row, date, period) {
      if (row.status === 1) {
        return '维修';
      } else if (row.status === 3) {
        return '休息';
      }

      if (!row.taskTimes || row.taskTimes.length === 0) {
        return '空闲';
      }

      var dateStr = this.formatDate(date, 'MM-DD');
      var tasks = row.taskTimes.filter(function (t) {
        return t.taskDate === dateStr;
      });

      if (tasks.length === 0) {
        return '空闲';
      }

      var periodTasks = tasks.filter(function (t) {
        if (!t.taskTime) return false;
        var parts = t.taskTime.split('-');

        if (parts.length < 2) {
          if (t.taskTime === '上午') return period === 'am';
          if (t.taskTime === '下午') return period === 'pm';
          if (t.taskTime === '全天') return true;
          return true;
        }

        var startHour = parseInt(parts[0].split(':')[0]);
        var endHour = parseInt(parts[1].split(':')[0]);

        if (period === 'am') {
          return startHour < 12;
        } else {
          return endHour > 12;
        }
      });

      if (periodTasks.length > 0) {
        return periodTasks.map(function (t) {
          return t.taskTime;
        }).filter(function (t) {
          return t;
        });
      }

      return '空闲';
    },
    getScheduleCellClassByPeriod: function getScheduleCellClassByPeriod(row, date, period) {
      var status = this.getScheduleStatusByPeriod(row, date, period);
      if (status === '维修') return 'busy';
      if (status === '休息') return 'rest';
      if (status === '空闲' && this.getSendTimeList(row, date, period).length === 0) return 'free';
      return 'occupied';
    },
    hasScheduleData: function hasScheduleData(row, date, period) {
      var status = this.getScheduleStatusByPeriod(row, date, period);

      if (status === '空闲' && this.getSendTimeList(row, date, period).length === 0) {
        return false;
      }

      return true;
    },
    getSendTimeList: function getSendTimeList(row, date, period) {
      if (!row.sendList || row.sendList.length === 0) {
        return [];
      }

      var dateStr = this.formatDate(date, 'MM-DD');
      return (0, _toConsumableArray2.default)(new Set(row.sendList.filter(function (item) {
        if (!item.sendDate || !item.sendTime) {
          return false;
        }

        var sendDate = new Date(item.sendDate);
        var month = String(sendDate.getMonth() + 1).padStart(2, '0');
        var day = String(sendDate.getDate()).padStart(2, '0');
        var itemDateStr = "".concat(month, "-").concat(day);

        if (itemDateStr !== dateStr) {
          return false;
        }

        var parts = item.sendTime.split('-');

        if (parts.length < 2) {
          return false;
        }

        var startHour = parseInt(parts[0].split(':')[0]);
        var endHour = parseInt(parts[1].split(':')[0]);

        if (period === 'am') {
          return startHour < 12;
        } else {
          return endHour > 12;
        }
      }).map(function (item) {
        return item.sendTime;
      }))).sort(function (a, b) {
        var aStart = a.split('-')[0];
        var bStart = b.split('-')[0];

        var _aStart$split$map = aStart.split(':').map(Number),
            _aStart$split$map2 = (0, _slicedToArray2.default)(_aStart$split$map, 2),
            aH = _aStart$split$map2[0],
            aM = _aStart$split$map2[1];

        var _bStart$split$map = bStart.split(':').map(Number),
            _bStart$split$map2 = (0, _slicedToArray2.default)(_bStart$split$map, 2),
            bH = _bStart$split$map2[0],
            bM = _bStart$split$map2[1];

        return aH * 60 + aM - (bH * 60 + bM);
      });
    },
    getTaskTimeList: function getTaskTimeList(row, date, period) {
      if (!row.taskTimes || row.taskTimes.length === 0) {
        return [];
      }

      var dateStr = this.formatDate(date, 'MM-DD');
      var tasks = row.taskTimes.filter(function (t) {
        return t.taskDate === dateStr;
      });

      if (tasks.length === 0) {
        return [];
      }

      var periodTasks = tasks.filter(function (t) {
        if (!t.taskTime) return false;
        var parts = t.taskTime.split('-');

        if (parts.length < 2) {
          if (t.taskTime === '上午') return period === 'am';
          if (t.taskTime === '下午') return period === 'pm';
          if (t.taskTime === '全天') return true;
          return true;
        }

        var startHour = parseInt(parts[0].split(':')[0]);
        var endHour = parseInt(parts[1].split(':')[0]);

        if (period === 'am') {
          return startHour < 12;
        } else {
          return endHour > 12;
        }
      });
      return (0, _toConsumableArray2.default)(new Set(periodTasks.map(function (t) {
        return t.taskTime;
      }).filter(function (t) {
        return t;
      }))).sort(function (a, b) {
        var aStart = a.split('-')[0];
        var bStart = b.split('-')[0];

        var _aStart$split$map3 = aStart.split(':').map(Number),
            _aStart$split$map4 = (0, _slicedToArray2.default)(_aStart$split$map3, 2),
            aH = _aStart$split$map4[0],
            aM = _aStart$split$map4[1];

        var _bStart$split$map3 = bStart.split(':').map(Number),
            _bStart$split$map4 = (0, _slicedToArray2.default)(_bStart$split$map3, 2),
            bH = _bStart$split$map4[0],
            bM = _bStart$split$map4[1];

        return aH * 60 + aM - (bH * 60 + bM);
      });
    },
    getTodayStatus: function getTodayStatus(taskTimes) {
      if (!taskTimes) return 0;
      var today = new Date();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');
      var todayStr = "".concat(month, "-").concat(day);
      var task = taskTimes.find(function (t) {
        return t.taskDate === todayStr;
      });
      return task && task.status !== undefined ? task.status : 0;
    },
    getTodayDate: function getTodayDate() {
      var today = new Date();
      var month = String(today.getMonth() + 1).padStart(2, '0');
      var day = String(today.getDate()).padStart(2, '0');
      return "".concat(month, "-").concat(day);
    },
    getStats: function getStats() {
      var _this2 = this;

      (0, _car.getCarStatistics)().then(function (res) {
        _this2.statsData = {
          totalVehicles: res.data.totalCars || 0,
          availableVehicles: res.data.availableCars || 0,
          busyVehicles: res.data.busyCars || 0
        };
      });
    },
    initTableHeight: function initTableHeight() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.tableHeight = window.innerHeight * 0.5;
      });
    },
    getList: function getList(startDate) {
      var _this4 = this;

      this.tableLoading = true;
      var params = {
        page: this.pagination.page - 1,
        size: this.pagination.size
      };

      if (startDate) {
        params.startDate = startDate;
      }

      if (this.searchForm.vehicleNumber) {
        params.carNumber = this.searchForm.vehicleNumber;
      }

      if (this.searchForm.energyType) {
        params.energy = this.searchForm.energyType;
      }

      (0, _car.getCarList)(params).then(function (res) {
        _this4.tableData = res.data.content || [];
        _this4.pagination.total = res.data.totalElements || 0;
        _this4.tableLoading = false;
      }).catch(function () {
        _this4.tableLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.page = val;
      this.getList();
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.getList(this.searchForm.date);
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        vehicleNumber: '',
        energyType: '',
        date: ''
      };
      this.handleSearch();
    },
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增车辆';
      this.form = {
        id: '',
        carNumber: '',
        brand: '',
        style: '',
        energy: '',
        volume: '',
        weight: '',
        size: '',
        box: '',
        userId: '',
        coordinateX: '',
        coordinateY: '',
        status: 0
      };
      this.dialogVisible = true;
    },
    handleDialogClose: function handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields();
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this5.submitLoading = true;
          var api = _this5.form.id ? _car.updateCar : _car.addCar;
          api(_this5.form).then(function (res) {
            if (res.code === 200) {
              _this5.$message.success(_this5.form.id ? '编辑成功' : '新增成功');

              _this5.dialogVisible = false;

              _this5.getList();

              _this5.getStats();
            } else {
              _this5.$message.error(res.msg || '操作失败');
            }
          }).catch(function () {
            _this5.$message.error('网络错误');
          }).finally(function () {
            _this5.submitLoading = false;
          });
        }
      });
    },
    handleEdit: function handleEdit(row) {
      this.dialogTitle = '编辑车辆';
      this.form = {
        id: row.id || '',
        carNumber: row.carNumber || '',
        brand: row.brand || '',
        style: row.style || '',
        energy: row.energy || '',
        volume: row.volume || '',
        weight: row.weight || '',
        size: row.size || '',
        box: row.box || '',
        userId: row.userId || '',
        coordinateX: row.coordinateX || '',
        coordinateY: row.coordinateY || '',
        status: row.status != null ? row.status : 0
      };
      this.dialogVisible = true;
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u8F66\u8F86 ".concat(row.carNumber, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _car.deleteCar)(row.id).then(function (res) {
          if (res.code === 200) {
            _this6.$message.success('删除成功');

            _this6.getList();

            _this6.getStats();
          } else {
            _this6.$message.error(res.msg || '删除失败');
          }
        }).catch(function () {
          _this6.$message.error('网络错误');
        });
      }).catch(function () {});
    },
    openMapSelector: function openMapSelector() {
      var _this7 = this;

      this.mapDialogVisible = true;
      this.$nextTick(function () {
        _this7.initMap();
      });
    },
    handleMapDialogClose: function handleMapDialogClose() {
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }

      this.tempCoordinate = '';
      this.searchKeyword = '';
      this.showSearchResults = false;
      this.searchResults = [];
    },
    initMap: function initMap() {
      var _this8 = this;

      if (this.map) {
        this.map.destroy();
        this.map = null;
      }

      this.tempCoordinate = this.form.coordinateX && this.form.coordinateY ? "".concat(this.form.coordinateX, ", ").concat(this.form.coordinateY) : '';

      var loadMapScript = function loadMapScript() {
        return new Promise(function (resolve, reject) {
          if (typeof window.AMap !== 'undefined') {
            resolve();
            return;
          }

          window._AMapSecurityConfig = {
            securityJsCode: _this8.amapSecurityJsCode
          };
          var callbackName = 'initAmapTransport_' + Date.now();

          window[callbackName] = function () {
            resolve();
            delete window[callbackName];
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = _this8.amapApi + '&callback=' + callbackName;
          script.async = true;
          script.defer = true;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      loadMapScript().then(function () {
        _this8.createMap();
      }).catch(function () {
        _this8.$message.error('地图加载失败，请刷新页面重试');
      });
    },
    createMap: function createMap() {
      var _this9 = this;

      try {
        var center = [108.370859, 22.678838];

        if (this.tempCoordinate) {
          var parts = this.tempCoordinate.split(',');

          if (parts.length === 2) {
            var lng = parseFloat(parts[0].trim());
            var lat = parseFloat(parts[1].trim());

            if (!isNaN(lng) && !isNaN(lat)) {
              center = [lng, lat];
            }
          }
        }

        this.map = new window.AMap.Map('mapContainer', {
          zoom: 14,
          center: center
        });
        window.AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], function () {
          _this9.map.addControl(new window.AMap.Scale());

          _this9.map.addControl(new window.AMap.ToolBar());
        });
        this.marker = new window.AMap.Marker({
          position: center,
          draggable: true
        });
        this.map.add(this.marker);
        this.map.on('click', function (e) {
          _this9.tempCoordinate = "".concat(e.lnglat.getLng(), ", ").concat(e.lnglat.getLat());

          _this9.marker.setPosition([e.lnglat.getLng(), e.lnglat.getLat()]);
        });
        this.marker.on('dragend', function () {
          var pos = _this9.marker.getPosition();

          _this9.tempCoordinate = "".concat(pos.getLng(), ", ").concat(pos.getLat());
        });
      } catch (e) {
        this.$message.error('地图初始化失败，请重试');
      }
    },
    handleSearchInput: function handleSearchInput() {
      var _this10 = this;

      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }

      this.searchTimer = setTimeout(function () {
        _this10.searchLocation();
      }, 300);
    },
    searchLocation: function searchLocation() {
      var _this11 = this;

      if (!this.searchKeyword) return;

      if (this.map && window.AMap) {
        window.AMap.plugin('AMap.PlaceSearch', function () {
          var placeSearch = new window.AMap.PlaceSearch({
            citylimit: false,
            pageSize: 10,
            pageIndex: 1
          });
          placeSearch.search(_this11.searchKeyword, function (status, result) {
            if (status === 'complete' && result.poiList) {
              _this11.searchResults = result.poiList.pois;
              _this11.showSearchResults = true;
            } else {
              _this11.searchResults = [];
              _this11.showSearchResults = false;
            }
          });
        });
      }
    },
    selectSearchResult: function selectSearchResult(result) {
      var lng = result.location.lng;
      var lat = result.location.lat;
      this.tempCoordinate = "".concat(lng, ", ").concat(lat);

      if (this.map) {
        this.map.setCenter([lng, lat]);
        this.marker.setPosition([lng, lat]);
      }

      this.showSearchResults = false;
      this.searchKeyword = result.name;
    },
    confirmMapSelection: function confirmMapSelection() {
      if (!this.tempCoordinate) {
        if (this.marker) {
          var pos = this.marker.getPosition();
          this.tempCoordinate = "".concat(pos.getLng(), ", ").concat(pos.getLat());
        } else if (this.map) {
          var center = this.map.getCenter();
          this.tempCoordinate = "".concat(center.getLng(), ", ").concat(center.getLat());
        }
      }

      if (this.tempCoordinate) {
        var parts = this.tempCoordinate.split(',');

        if (parts.length === 2) {
          this.form.coordinateX = parts[0].trim();
          this.form.coordinateY = parts[1].trim();
        }
      }

      this.mapDialogVisible = false;
    },
    handleViewModeChange: function handleViewModeChange(mode) {
      var _this12 = this;

      if (mode === 'map') {
        this.$nextTick(function () {
          _this12.initVehicleMap();
        });
      }
    },
    initVehicleMap: function initVehicleMap() {
      var _this13 = this;

      if (this.vehicleMap) {
        this.addVehicleMarkers();
        return;
      }

      var loadMapScript = function loadMapScript() {
        return new Promise(function (resolve, reject) {
          if (typeof window.AMap !== 'undefined') {
            resolve();
            return;
          }

          window._AMapSecurityConfig = {
            securityJsCode: _this13.amapSecurityJsCode
          };
          var callbackName = 'initVehicleMap_' + Date.now();

          window[callbackName] = function () {
            resolve();
            delete window[callbackName];
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = _this13.amapApi + '&callback=' + callbackName;
          script.async = true;
          script.defer = true;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      };

      loadMapScript().then(function () {
        _this13.createVehicleMap();
      }).catch(function () {
        _this13.$message.error('地图加载失败，请刷新页面重试');
      });
    },
    createVehicleMap: function createVehicleMap() {
      var _this14 = this;

      try {
        var vehiclesWithCoord = this.tableData.filter(function (v) {
          return v.coordinateX && v.coordinateY;
        });
        var center = [108.370859, 22.678838];

        if (vehiclesWithCoord.length > 0) {
          var lngs = vehiclesWithCoord.map(function (v) {
            return parseFloat(v.coordinateX);
          });
          var lats = vehiclesWithCoord.map(function (v) {
            return parseFloat(v.coordinateY);
          });
          var avgLng = lngs.reduce(function (a, b) {
            return a + b;
          }, 0) / lngs.length;
          var avgLat = lats.reduce(function (a, b) {
            return a + b;
          }, 0) / lats.length;
          center = [avgLng, avgLat];
        }

        this.vehicleMap = new window.AMap.Map('vehicleMapContainer', {
          zoom: 12,
          center: center,
          resizeEnable: true
        });
        window.AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], function () {
          _this14.vehicleMap.addControl(new window.AMap.Scale());

          _this14.vehicleMap.addControl(new window.AMap.ToolBar());
        });
        this.vehicleInfoWindow = new window.AMap.InfoWindow({
          offset: new window.AMap.Pixel(0, -30)
        });
        this.addVehicleMarkers();
      } catch (e) {
        this.$message.error('地图初始化失败，请重试');
      }
    },
    addVehicleMarkers: function addVehicleMarkers() {
      var _this15 = this;

      if (!this.vehicleMap) return;
      this.vehicleMarkers.forEach(function (m) {
        return _this15.vehicleMap.remove(m);
      });
      this.vehicleMarkers = [];
      var vehiclesWithCoord = this.tableData.filter(function (v) {
        return v.coordinateX && v.coordinateY;
      });
      if (vehiclesWithCoord.length === 0) return;
      var statusColorMap = {
        0: '#67C23A',
        1: '#F56C6C',
        3: '#909399'
      };
      vehiclesWithCoord.forEach(function (v) {
        var lng = parseFloat(v.coordinateX);
        var lat = parseFloat(v.coordinateY);
        if (isNaN(lng) || isNaN(lat)) return;
        var color = statusColorMap[v.status] || '#409EFF';
        var statusLabel = {
          0: '正常',
          1: '维修',
          3: '休息'
        }[v.status] || '未知';
        var content = [];
        content.push("<div style=\"padding:4px 8px;font-size:13px;min-width:160px;\">");
        content.push("<strong style=\"font-size:14px;\">".concat(v.carNumber || '', "</strong>"));

        if (v.brand || v.style) {
          content.push("<span style=\"color:#909399;margin-left:8px;\">".concat(v.brand || '', " ").concat(v.style || '', "</span>"));
        }

        content.push("<br/>");
        content.push("<span>\u72B6\u6001\uFF1A<span style=\"color:".concat(color, ";font-weight:500;\">").concat(statusLabel, "</span></span><br/>"));

        if (v.energy) {
          content.push("<span>\u80FD\u6E90\uFF1A".concat(v.energy, "</span><br/>"));
        }

        content.push("</div>");
        var marker = new window.AMap.Marker({
          position: [lng, lat],
          title: v.carNumber,
          offset: new window.AMap.Pixel(-12, -16),
          content: "<div class=\"vehicle-marker\" style=\"\n            width:24px;height:24px;border-radius:50%;\n            background:".concat(color, ";\n            border:2px solid #fff;\n            box-shadow:0 2px 6px rgba(0,0,0,0.3);\n            display:flex;align-items:center;justify-content:center;\n            cursor:pointer;\n          \"><span style=\"color:#fff;font-size:11px;font-weight:bold;\">\uD83D\uDE9A</span></div>")
        });
        marker.vehicleData = v;
        marker.on('click', function () {
          _this15.vehicleInfoWindow.setContent(content.join(''));

          _this15.vehicleInfoWindow.open(_this15.vehicleMap, marker.getPosition());
        });

        _this15.vehicleMap.add(marker);

        _this15.vehicleMarkers.push(marker);
      });

      if (vehiclesWithCoord.length > 0) {
        this.vehicleMap.setFitView(null, false, [60, 60, 60, 60]);
      }
    }
  }
};
exports.default = _default;